// Helper para enviar mensagens pelo WhatsApp (abre web/app com texto pré-preenchido).
// Se phone for passado, abre conversa direta; senão, abre picker.
// Phone é limpo (só dígitos). Se não tiver DDI, assume 55 (Brasil).

export const sanitizePhone = (phone) => {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");
  if (!digits) return "";
  // Se já tem 12-13 dígitos (DDI + DDD + número), usa como está
  if (digits.length >= 12) return digits;
  // Se tem 10-11 (DDD+numero), prepend 55
  if (digits.length >= 10) return "55" + digits;
  return digits; // deixa como está, pode falhar
};

export const whatsappUrl = (phone, message) => {
  const text = encodeURIComponent(message || "");
  const p = sanitizePhone(phone);
  if (p) return `https://wa.me/${p}?text=${text}`;
  // Sem telefone: abre picker do WhatsApp
  return `https://wa.me/?text=${text}`;
};

export const openWhatsapp = (phone, message) => {
  const url = whatsappUrl(phone, message);
  window.open(url, "_blank", "noopener");
};

// Formatador de valores em reais
const BRL = (v) =>
  (parseFloat(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const formatCommunityPurchaseMessage = (g) => {
  const lines = [];
  lines.push(`🧾 *COOMFLONA · Recibo ${g.numero}*`);
  lines.push("");
  lines.push(`👤 ${g.cooperado_tipo === "comunitario" ? "Comunitário" : "Cooperado"}: *${g.cooperado_nome}*`);
  if (g.cooperado_cpf) lines.push(`📄 CPF: ${g.cooperado_cpf}`);
  if (g.community_nome) lines.push(`🏘️ Comunidade: ${g.community_nome}`);
  if (g.data_compra) {
    const d = new Date(g.data_compra);
    lines.push(`📅 Data: ${d.toLocaleDateString("pt-BR")}`);
  }
  lines.push("");
  lines.push("📦 *Itens*");
  (g.itens || []).forEach((it, i) => {
    lines.push(`${i + 1}. ${it.product_nome} — ${it.quantidade}× ${BRL(it.valor_unitario)} = *${BRL(it.valor_total)}*`);
  });
  lines.push("");
  lines.push(`💰 *Total: ${BRL(g.valor_total)}*`);
  if (g.forma_pagamento) lines.push(`💳 Pagamento: ${g.forma_pagamento.replace("_", " ")}`);
  if (g.nota_fiscal) lines.push(`📄 NF: ${g.nota_fiscal}`);
  lines.push("");
  lines.push("_COOMFLONA · Cooperativa Mista da Floresta Nacional do Tapajós_");
  return lines.join("\n");
};

export const formatPaymentOrderMessage = (op) => {
  const lines = [];
  lines.push(`💼 *COOMFLONA · Ordem de Pagamento ${op.numero}*`);
  lines.push("");
  lines.push(`👤 Beneficiário: *${op.beneficiario}*`);
  if (op.cnpj_cpf) lines.push(`📄 CNPJ/CPF: ${op.cnpj_cpf}`);
  if (op.data_vencimento) {
    const d = op.data_vencimento.slice(0, 10).split("-").reverse().join("/");
    lines.push(`📅 Vencimento: ${d}`);
  }
  if (op.descricao) lines.push(`📝 ${op.descricao}`);
  lines.push("");
  if ((op.itens || []).length > 0) {
    lines.push("📦 *Itens*");
    op.itens.forEach((it, i) => {
      lines.push(`${i + 1}. ${it.descricao} — ${it.quantidade}× ${it.unidade} = *${BRL(it.valor)}*`);
    });
    lines.push("");
  }
  lines.push(`💰 *Total: ${BRL(op.valor_total)}*`);
  if (op.forma_pagamento) lines.push(`💳 Forma: ${op.forma_pagamento.replace("_", " ")}`);
  if (op.dados_pagamento) lines.push(`🔑 Dados: ${op.dados_pagamento}`);
  if (op.status) lines.push(`📌 Status: ${op.status.toUpperCase()}`);
  lines.push("");
  lines.push("_COOMFLONA · Cooperativa Mista da Floresta Nacional do Tapajós_");
  return lines.join("\n");
};
